import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

const requireAuthenticated = (to, from, next) => {
  store.dispatch('INITIALIZE').then(() => {
    if (!store.getters.isAuthenticated) {
      next('/login')
    } else {
      next()
    }
  })
}

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/Home.vue')
      // beforeEnter: requireUnauthenticated
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue')
      // beforeEnter: requireUnauthenticated
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('./views/Profile/index.vue'),
      beforeEnter: requireAuthenticated,
      redirect: '/profile/adverts',
      children: [
        {
          path: '/profile/adverts',
          name: 'profile-adverts',
          component: () => import('./views/Profile/AdvertsPage.vue'),
          beforeEnter: requireAuthenticated
        },
        {
          path: '/profile/company',
          name: 'profile-company',
          component: () => import('./views/Profile/CompanyPage.vue'),
          beforeEnter: requireAuthenticated
        },
        {
          path: '/profile/complexes',
          name: 'profile-complexes',
          component: () => import('./views/Profile/ComplexesPage.vue'),
          beforeEnter: requireAuthenticated
        }
      ]
    },
    {
      path: '/map',
      name: 'map',
      component: () => import('./views/Advert/AdvertList.vue')
      // beforeEnter: requireUnauthenticated
    },
    {
      path: '/advert',
      name: 'advert-list',
      component: () => import('./views/Advert'),
      redirect: '/advert/list',
      children: [
        {
          path: '/advert/list/:type',
          component: () => import('./views/Advert/AdvertList.vue'),
          props: true
        },
        {
          path: '/advert/item/add',
          component: () => import('./views/Advert/AddNewAdvert.vue'),
          beforeEnter: requireAuthenticated,
          meta: { key: 'add' }
        },
        {
          path: '/advert/item/edit/:id',
          component: () => import('./views/Advert/AddNewAdvert.vue'),
          beforeEnter: requireAuthenticated,
          meta: { key: 'edit' }
        },
        {
          path: '/advert/:id',
          component: () => import('./views/Advert/AdvertPage.vue')
        }
      ]
    },
    {
      path: '/company',
      name: 'company-list',
      component: () => import('./views/Company'),
      redirect: '/company/list',
      children: [
        {
          path: '/company/list',
          component: () => import('./views/Company/CompanyList.vue')
        },
        {
          path: '/company/item/add',
          component: () => import('./views/Company/CompanyAdd.vue')
        },
        {
          path: '/company/list/:id',
          component: () => import('./views/Company/CompanyPage.vue')
        }
      ]
    },
    {
      path: '/complex',
      component: () => import('./views/Complex'),
      redirect: '/complex/list',
      children: [
        {
          path: '/complex/list',
          component: () => import('./views/Complex/ComplexList.vue')
        },
        {
          path: '/complex/item/add',
          component: () => import('./views/Complex/ComplexAdd.vue'),
          beforeEnter: requireAuthenticated
        },
        {
          path: '/complex/:id',
          component: () => import('./views/Complex/ComplexPage.vue')
        }
      ]
    },
    {
      path: '/favorites',
      name: 'favorites',
      component: () => import('./views/Favorites.vue'),
      beforeEnter: requireAuthenticated
    }
  ]
})
